import React from 'react'
import { PortRequestDeclineInfo } from '@utils/portRequestPayload.util'
import './PortRequestShared.css'

type Props = {
  declineInfo: PortRequestDeclineInfo
}

const PortRequestDeclineBanner: React.FC<Props> = ({ declineInfo }) => (
  <div className="scp-port-request-decline-banner">
    <span className="scp-prdb-title">Request declined</span>
    {declineInfo.reason ? (
      <span className="scp-prdb-reason">{declineInfo.reason}</span>
    ) : null}
    {declineInfo.note ? (
      <span className="scp-pordb-note">{declineInfo.note}</span>
    ) : null}
    {!declineInfo.reason && !declineInfo.note ? (
      <span className="scp-prdb-note">
        Update the details below and resubmit for review.
      </span>
    ) : null}
  </div>
)

export default PortRequestDeclineBanner
